/**
 * The ONLY sanctioned way to render a search snippet (`070-search-and-links.md` §5).
 *
 * Lives in `components/`, not in a feature folder, because two features render it (the
 * palette and — from M5 — the search results page), and a `features/*` folder may not
 * import from another (`111` §2).
 *
 * **No `dangerouslySetInnerHTML`. Not here, not anywhere, not "after checking it looks
 * fine".** The tokens come from `parseSnippet`, which cannot emit an element other than
 * `mark`, and React escapes every string child — so a `<script>` or an `onerror=` sitting
 * in the page's own text renders as literal, harmless characters. There is no HTML parsing
 * step, and therefore no sanitizer bypass to get wrong.
 */
import { parseSnippet } from '@/lib/snippet';
import { cn } from '@/lib/utils';

export function SearchSnippet({ html, className }: { html: string; className?: string }) {
  const tokens = parseSnippet(html);

  return (
    <span className={cn('block truncate text-[var(--muted-foreground)]', className)}>
      {tokens.map((token, i) =>
        token.kind === 'mark' ? (
          <mark
            // Index keys: the token list is derived, positional, and never reordered.
            key={i}
            className="rounded-[2px] bg-[var(--mark)] px-[1px] text-[var(--foreground)]"
          >
            {token.value}
          </mark>
        ) : (
          <span key={i}>{token.value}</span>
        ),
      )}
    </span>
  );
}
